import Vue from 'vue'
import VueRouter from 'vue-router'
import UserLoginView from "@/views/UserLoginView";
import Layout from "@/components/layout/Layout";

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'userLogin',
            component: UserLoginView
        },
        {
            path: '/public/checkout-pallet',
            name: 'public-checkout-pallet',
            component: () => import(/* webpackChunkName: "public-checkout-pallet" */ '../views/PublicCheckoutPallet')
        },
        {
            // Short, QR-friendly URL: /p/1757423164502
            path: '/p/:palletNumber',
            name: 'public-checkout-pallet-short',
            component: () => import(/* webpackChunkName: "public-checkout-pallet" */ '../views/PublicCheckoutPallet')
        },
        {
            // Ultra-short, no extra slash: /p1757423164502
            path: '/p:palletNumber',
            name: 'public-checkout-pallet-ultra-nodelim',
            component: () => import(/* webpackChunkName: "public-checkout-pallet" */ '../views/PublicCheckoutPallet')
        },
        {
            // Short with hyphen: /p-1757423164502
            path: '/p-:palletNumber',
            name: 'public-checkout-pallet-ultra-hyphen',
            component: () => import(/* webpackChunkName: "public-checkout-pallet" */ '../views/PublicCheckoutPallet')
        },

        {
            path: '/',
            component: Layout,
            children : [
                {
                    path: '/pending-orders',
                    name: 'pending-orders',
                    component: () => import(/* webpackChunkName: "pending-orders" */ '../views/PendingOrdersView')
                },
                {
                    path: '/view-order',
                    name: 'view-order',
                    component: () => import(/* webpackChunkName: "view-order" */ '../views/ViewOrder')
                },
            ],
        },
    ]
})

export default router
